import { useMissionsTranslation } from '../../../../../ui/hooks';
import { usePermission } from '@juvare/contact-management/ui/hooks';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import React from 'react';
export const PastShiftsSwitch = ({ pastShiftTab, setPastShiftTab }) => {
    const { t } = useMissionsTranslation();
    const { requireAnySystemPermission } = usePermission();
    const allowMissionChange = requireAnySystemPermission('manage-missions', 'manage-all-admin-missions');
    if (!allowMissionChange) {
        return null;
    }
    return (React.createElement(Box, { sx: {
            ml: 'auto',
            zIndex: 1,
        } },
        React.createElement(ToggleButtonGroup, { exclusive: true, value: pastShiftTab, onChange: (_event, value) => {
                setPastShiftTab(value !== null && value !== void 0 ? value : pastShiftTab);
            } },
            React.createElement(ToggleButton, { value: 'shift', "data-test": 'shift-toggle-button' }, t('missions.tabs.shift')),
            React.createElement(ToggleButton, { value: 'volunteers', "data-test": 'volunteers-toggle-button' }, t('missions.tabs.volunteers')))));
};
